export class NumberHelper {
  /**
   *
   */
  static convertIntToDecimal(amount: number): number {
    return amount / 100;
  }
}
